import { Link } from 'react-router-dom';
import { Section } from '@/components/Section';

export function NotFoundPage() {
  return (
    <Section eyebrow="404" title="Page not found.">
      <Link to="/" className="btn-primary">
        Back home
      </Link>
    </Section>
  );
}
